const GeneralList = ({ page, columns, listLength, availableLists, userHasPremium, contents }) => {
    return {
        page: page,
        columns: columns,
        listLength: listLength,
        userHasPremium: userHasPremium,
        availableLists: availableLists,
        list: [],
        loading: false,

        init () {
            this.$nextTick(() => document.getElementById('skeleton')?.remove());
            this.setList();

            this.$watch('page', () => this.setList());
            this.$watch('list', () => this.$dispatch('update-thumb'));
        },

        setList() {
            const lastItem = this.page * paginationSize;

            this.list = contents.slice(lastItem - paginationSize, lastItem);
        }
    }
}

export default GeneralList;
